import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from '@/store/store'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

require('./assets/css/style.css')

Vue.use(VueLazyload, { lazyComponent: true })

new Vue({
  router,
  store: store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
